import Images, { variants, ImagesProps } from './Images';

const NarrowImages = (props: ImagesProps) => (
  <Images variant={variants[1]} {...props} />
);

export default NarrowImages;
